const SPEEDUP = 3

module.exports = {
    "frames": [
        {
            "time": -32 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_00.png").default
        },
        {
            "time": 0 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_01.png").default
        },
        {
            "time": 32 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_02.png").default
        },
        {
            "time": 64 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_03.png").default
        },
        {
            "time": 96 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_04.png").default
        },
        {
            "time": 128 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_05.png").default
        },
        {
            "time": 160 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_06.png").default
        },
        {
            "time": 192 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_07.png").default
        },
        {
            "time": 224 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_08.png").default
        },
        {
            "time": 256 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_09.png").default
        },
        {
            "time": 288 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_10.png").default
        },
        {
            "time": 320 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_11.png").default
        },
        {
            "time": 352 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_12.png").default
        },
        {
            "time": 384 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_13.png").default
        },
        {
            "time": 416 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_14.png").default
        },
        {
            "time": 448 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_15.png").default
        },
        {
            "time": 480 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_16.png").default
        },
        {
            "time": 512 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_17.png").default
        },
        {
            "time": 544 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_18.png").default
        },
        {
            "time": 576 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_19.png").default
        },
        {
            "time": 608 * SPEEDUP,
            "image": require("@frog/source/assets/images/bomber-tactics/title/screen/title-screen_20.png").default
        },
        {
            "time": 640 * SPEEDUP
        }
    ]
}
